import myAppConfig from "@/apps/my-app/app.config"
import homeConfig from "@/apps/home/app.config"
import supportConfig from "@/apps/tutorials/app.config"
import customLeftNav from "@/apps/custom-left-nav/app.config"
import medAppReqConfig from "@/apps/med-app-req/app.config"


var configs = [
    // myAppConfig,
    // homeConfig,
    // supportConfig,
    // customLeftNav,
    medAppReqConfig
];


var registrationConfig = configs.map(e => {
    return {
        store: e.storeModule,
        route: e.route,
    }
});

export default registrationConfig;
